import React, { useState, useRef } from "react";
import "./Transportation_of_building_materials.css";
import { Link } from "react-router-dom";
import ContactSection2 from "../Category/ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Transportation_of_building_materials() {
  return (
    <div className="Transportation_of_building_materials-page">

      <div className="Transportation_of_building_materials-hero">
        <div className="Transportation_of_building_materials-overlay">
          <h1>הובלת חומרי בניין</h1>
        </div>
      </div>

      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הובלת חומרי בניין
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/14.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את שירותי הובלת חומרי הבניין של נצר הובלות ומנופים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הובלת חומרי בניין דורשת תכנון נכון, ציוד מתאים וניסיון
            בעבודה עם מטענים בגדלים ובמשקלים שונים. נצר הובלות ומנופים
            מספקת שירותי הובלת חומרי בניין לקבלנים, חברות, עסקים ולקוחות
            פרטיים, בהתאם לצורכי ההובלה ולתנאי השטח.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/19.jpeg"
                alt="הובלת חומרי בניין"
              />
            </div>

            <div className="text-box">

              <p>
                הובלת חומרי בניין דורשת התאמה בין סוג המטען, המשקל,
                מידות הציוד ותנאי הגישה במקום האיסוף והפריקה. לפני
                ביצוע ההובלה חשוב לבחון את סוג החומר, כמות המטען,
                אמצעי ההעמסה והפריקה והאפשרות להגיע בבטחה לנקודת היעד.
              </p>

              <p>
                נצר הובלות ומנופים מספקת פתרונות להובלת מגוון חומרי
                בניין, לרבות חומרי בנייה ארוזים, משטחים, בלוקים,
                לבנים, לוחות, ציוד בניין, חומרי גמר וציוד נוסף,
                בהתאם לסוג ההובלה ולתנאים בשטח.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הובלת חומרי בניין – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל הובלת חומרי בניין מתחילה בבדיקת פרטי ההובלה.
              יש להבין מהו סוג המטען, מה הכמות, מה המשקל הכולל,
              מהן מידות המטען ומהי נקודת האיסוף והפריקה.
            </p>

            <p>
              בנוסף יש לבחון את תנאי הדרך ואת הגישה לאתר, לרבות
              רחובות צרים, חניות, אתרי בנייה, כניסות מורכבות ומגבלות
              אחרות שעלולות להשפיע על ביצוע ההובלה.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הובלת חומרי בניין באמצעות משאית
            </h2>

            <p>
              משאית מתאימה מאפשרת להעביר כמויות שונות של חומרי בניין
              מאתר אחד לאחר בצורה מסודרת. התאמת המשאית נעשית בהתאם
              לסוג המטען, לנפח ההובלה, למשקל ולתנאי הגישה.
            </p>

            <p>
              במקרים שבהם יש צורך גם בהעמסה או בפריקה באמצעות מנוף,
              ניתן לשלב פתרון הכולל הובלה ומנוף בהתאם לדרישות העבודה
              ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הובלת חומרי בניין לאתרי בנייה
            </h2>

            <p>
              באתרי בנייה יש לעיתים צורך באספקה שוטפת של חומרי גלם
              וציוד. הובלה מסודרת מאפשרת להעביר את החומרים אל האתר
              בהתאם לתכנון העבודה ולשלבי הפרויקט.
            </p>

            <p>
              נצר הובלות ומנופים מספקת שירותי הובלת חומרי בניין
              לאתרי בנייה ולמגוון נקודות ברחבי הארץ, בהתאם לצורכי
              הלקוח ולתנאי השטח.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הובלת חומרי בניין עם מנוף
            </h2>

            <p>
              במקרים שבהם נקודת הפריקה אינה נגישה ישירות למשאית,
              ניתן להשתמש במנוף לצורך הרמת חומרי הבניין והעברתם
              אל נקודת הפריקה המתאימה, בהתאם לאפשרויות העבודה בשטח.
            </p>

            <p>
              שילוב של הובלה ומנוף יכול לסייע במקרים שבהם נדרשת
              הרמה של משטחים, ציוד או חומרי בניין אל אזורים שבהם
              אין אפשרות לפריקה רגילה.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הובלת משטחים וחומרי בניין כבדים
            </h2>

            <p>
              חומרי בניין רבים מגיעים על גבי משטחים או באריזות
              המיועדות להובלה מרוכזת. לפני ביצוע העבודה יש לבדוק
              את משקל המטען ואת אופן ההעמסה והפריקה.
            </p>

            <p>
              בהתאם לסוג העבודה ניתן לתכנן את ההובלה כך שתתאים
              לכמות המטען, למידותיו ולתנאי הגישה באתר.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להובלת חומרי בניין?
            </h2>

            <p>
              הובלת חומרי בניין דורשת היכרות עם סוגי מטענים שונים,
              תכנון נכון והתאמת אמצעי ההובלה למשימה. בדיקה מוקדמת
              של תנאי השטח יכולה לסייע בתכנון יעיל של ההובלה.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההובלה לסוג החומר,
              לכמות המטען, לתנאי הדרך ולדרישות הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הובלת חומרי בניין בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הובלת חומרי בניין,
              ציוד וחומרים לאתרי בנייה, עסקים ולקוחות פרטיים.
              השירות ניתן בהתאם לסוג ההובלה ולתנאים הקיימים בשטח.
            </p>

            <p>
              צריכים הובלת חומרי בניין? צרו איתנו קשר, ספרו לנו
              מה אתם צריכים להוביל ונבחן עבורכם את פתרון ההובלה
              המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Transportation_of_industrial_and_heavy_generators"
              className="link-right"
            >
הובלת גנרטורים תעשייתיים כבדים            </Link>

            <Link
              to="/Transporting_wood"
              className="link-left"
            >
הובלת עצים            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}
